import {getFeaturedWidgetData, getWidgetData} from '@wix/ambassador-events-ui-v1-widget-data/http'
import {
  EventFilter,
  EventSortOrder,
  GetFeaturedWidgetDataResponse,
  GetWidgetDataResponse,
  ListLayout,
  RecurringFilter,
  WidgetType,
} from '@wix/ambassador-events-ui-v1-widget-data/types'
import {
  EVENT_FILTER_TYPE,
  EVENT_SORT_ORDER,
  EventsHttpClient,
  LIST_LAYOUT,
  RECURRING_FILTER,
  WIDGET_TYPE,
} from '@wix/wix-events-commons-statics'
import {GetFeaturedWidgetDataParams, GetWidgetDataParams} from './shared-api'

// Mapping is temporarily done here for new api
// Later code will be refactored step by step to avoid this mapping
export const getWidgetDataServerless =
  (api: EventsHttpClient) =>
  async ({
    responsive,
    locale,
    language,
    compId,
    viewMode,
    members,
    paidPlans,
    widgetType: widgetTypeParam,
    listLayout: listLayoutParam,
    recurringFilter: recurringFilterParam,
    showcase,
    tz,
    filterType,
    sortOrder: sortOrderParam,
    categoryId,
    limit,
    fetchCategoryId,
    fetchAllCategories,
    editor3,
    calendarEvents,
  }: GetWidgetDataParams): Promise<GetWidgetDataResponse> => {
    const categoryIds = Array.isArray(categoryId) ? categoryId : categoryId !== undefined ? [categoryId] : undefined

    const eventFilterMap: Record<EVENT_FILTER_TYPE, EventFilter> = {
      [EVENT_FILTER_TYPE.MANUAL]: EventFilter.MANUAL,
      [EVENT_FILTER_TYPE.PAST]: EventFilter.PAST,
      [EVENT_FILTER_TYPE.UPCOMING]: EventFilter.UPCOMING,
      [EVENT_FILTER_TYPE.UPCOMING_AND_PAST]: EventFilter.UPCOMING_AND_PAST,
    }

    const recurringFilterMap: Record<RECURRING_FILTER, RecurringFilter> = {
      [RECURRING_FILTER.COLLAPSED]: RecurringFilter.COLLAPSED,
      [RECURRING_FILTER.ALL]: RecurringFilter.ALL,
    }

    const sortOrderMap: Record<EVENT_SORT_ORDER, EventSortOrder> = {
      [EVENT_SORT_ORDER.MANUAL]: EventSortOrder.MANUAL_SORT,
      [EVENT_SORT_ORDER.CHRONOLOGICAL]: EventSortOrder.CHRONOLOGICAL,
    }

    const widgetTypeMap: Record<WIDGET_TYPE, WidgetType> = {
      [WIDGET_TYPE.FEATURED]: WidgetType.FEATURED,
      [WIDGET_TYPE.LIST]: WidgetType.MULTIPLE,
      [WIDGET_TYPE.SINGLE]: WidgetType.SINGLE,
    }

    const listLayoutMap: Record<LIST_LAYOUT, ListLayout> = {
      [LIST_LAYOUT.LIST]: ListLayout.LIST,
      [LIST_LAYOUT.GRID]: ListLayout.GRID,
      [LIST_LAYOUT.NEW_GRID]: ListLayout.NEW_GRID,
      [LIST_LAYOUT.SIDE_BY_SIDE]: ListLayout.SIDE_BY_SIDE,
      [LIST_LAYOUT.CALENDAR]: ListLayout.CALENDAR,
      [LIST_LAYOUT.ON_IMAGE]: ListLayout.ON_IMAGE,
    }

    const eventFilter = eventFilterMap[filterType]
    const recurringFilter = recurringFilterMap[recurringFilterParam]
    const sortOrder = sortOrderMap[sortOrderParam]
    const widgetType = widgetTypeMap[widgetTypeParam] ?? WidgetType.MULTIPLE
    const listLayout = listLayoutMap[listLayoutParam] ?? ListLayout.NEW_GRID

    return api.request(
      getWidgetData({
        compId,
        locale,
        language,
        tz,
        viewMode,
        widgetType,
        listLayout,
        eventFilter,
        recurringFilter,
        sortOrder,
        categoryIds,
        fetchCategoryIds: fetchCategoryId,
        limit,
        showcase,
        responsive,
        fetchMembers: members,
        fetchPaidPlans: paidPlans,
        fetchBadges: true,
        fetchAllCategories,
        editor3,
        calendarEvents,
        ...((calendarEvents || listLayout === ListLayout.CALENDAR) && {
          today: new Date().toLocaleDateString('en-CA', {timeZone: tz}), // So the cache resets at least everyday
        }),
      }),
    )
  }

export const getFeaturedWidgetDataServerless =
  (api: EventsHttpClient) =>
  async ({
    eventId,
    categoryId,
    locale,
    language,
    tz,
    viewMode,
    manuallySelected,
    responsive,
    members,
    paidPlans,
    editor3,
  }: GetFeaturedWidgetDataParams): Promise<GetFeaturedWidgetDataResponse> => {
    return api.request(
      getFeaturedWidgetData({
        eventId,
        categoryId,
        locale,
        language,
        tz,
        viewMode,
        manuallySelected,
        responsive,
        fetchMembers: members,
        fetchPaidPlans: paidPlans,
        fetchBadges: true,
        editor3,
      }),
    )
  }
